(function ($) {
    $(document).ready(function () {

        $('.ua-firefox .list-grid').addClass("cl-firefox");


        $('.form-contact .webform-flex #edit-country').on('change',function () {
            var optn= $(this).val();
            if(optn!=='United States') {
                $('.form-contact .webform-flex #edit-state').removeAttr('required');
                $('.form-contact label[for="edit-state"] span').css('display','none');
            }else {
                $('.form-contact .webform-flex #edit-state').attr('required','required');
                $('.form-contact label[for="edit-state"] span').css('display','inline-block');
            }
        });
    });
})(jQuery);
